import React, {useContext, useEffect, useState} from 'react'
import {MenuItem, TextField} from "@mui/material";
import http from "../../http";
import {OrgCustomizationContext} from "../../themes/OrgCustomizationProvider";

type CountryRecord = { name: string, code: string }

type CountrySelectInputProps = {
    name: string
    label: string
    value: string
    defaultValue?: string
    onChange: React.ChangeEventHandler<HTMLInputElement>
    error: boolean
    helperText: React.ReactNode
    whitelist?: string[]
}

let cachedCountries: { countries: CountryRecord[], language: string } = {
    countries: [],
    language: ''
}

const CountrySelectInput: React.FC<CountrySelectInputProps> = ({
                                                                   name,
                                                                   label,
                                                                   onChange,
                                                                   value,
                                                                   defaultValue,
                                                                   error,
                                                                   helperText,
                                                                   whitelist
                                                               }) => {
    const {language} = useContext(OrgCustomizationContext);
    const [countries, setCountries] = useState<CountryRecord[]>(cachedCountries.countries)

    useEffect(() => {
        (countries.length === 0 || cachedCountries.language !== language) && http.get<CountryRecord[]>(`/api/Country?lang=${language}`)
            .then(({data}) => {
                cachedCountries = {countries: data, language}
                setCountries(data)
            })
            .catch((error) => console.log('Country Data Retrieval:', error))
    }, [language, countries.length])

    return (
        <TextField
            select
            label={label}
            name={name}
            variant="outlined"
            onChange={onChange}
            fullWidth
            sx={{margin: '1rem', backgroundColor: 'white'}}
            value={value}
            defaultValue={defaultValue}
            error={error}
            helperText={helperText}
        >
            {
                countries
                    .filter(c => whitelist ? whitelist.includes(c.code) : true)
                    .sort((a, b) => a.name < b.name ? -1 : a.name > b.name ? 1 : 0)
                    .map(i => <MenuItem key={i.code} value={i.code}>{i.name}</MenuItem>)
            }
        </TextField>
    )
}

export default CountrySelectInput
